import { useMemo } from 'react';
import { Colors } from '@tapresearch/ui/components';
export var useColorScheme = function() {
    return useMemo(function() {
        var red = Colors.red, teal = Colors.teal, orange = Colors.orange, purple = Colors.purple, green = Colors.green, fuschia = Colors.fuschia, cyan = Colors.cyan, forest_green = Colors.forest_green;
        var colorsArray = [
            red,
            teal,
            orange,
            purple,
            green,
            fuschia,
            cyan,
            forest_green
        ];
        var colorWeights = [
            300,
            400,
            500,
            600,
            700,
            800
        ];
        return colorWeights.map(function(weight) {
            return colorsArray.map(function(color) {
                return color[weight];
            });
        }).reduce(function(acc, color) {
            return acc.concat(color);
        }, []);
    }, []);
};
